import axios from 'axios'

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/baier' : '/baier',
  timeout: 15000,
})

let websiteToken = ''
let websiteTokenPromise = null

async function ensureWebsiteToken() {
  if (websiteToken) return websiteToken
  if (!websiteTokenPromise) {
    websiteTokenPromise = request.post('/website/token').then((res) => {
      websiteToken = res?.token || ''
      return websiteToken
    }).catch(() => '').finally(() => {
      websiteTokenPromise = null
    })
  }
  return websiteTokenPromise
}

request.interceptors.request.use(
  async (config) => {
    const url = config.url || ''
    if (url.startsWith('/website/lead/')) {
      const token = await ensureWebsiteToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  (error) => Promise.reject(error)
)

request.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res && typeof res === 'object' && 'code' in res) {
      if (res.code === 0 || res.code === 200) {
        return res.data !== undefined ? res.data : res
      }
      const err = new Error(res.message || res.msg || '请求失败')
      err.isBusiness = true
      err.code = res.code
      err.response = response
      return Promise.reject(err)
    }
    return res
  },
  (error) => {
    error.isNetwork = !error.response
    return Promise.reject(error)
  }
)

/**
 * @param {boolean} networkOnly 为 true 时：仅断网才回退 mock（写操作必须用，避免业务失败却提示成功）
 */
export async function withMock(fetchFn, mockData, { networkOnly = false } = {}) {
  try {
    return await fetchFn()
  } catch (e) {
    if (networkOnly && (e?.isBusiness || e?.response)) {
      throw e
    }
    return typeof mockData === 'function' ? mockData() : mockData
  }
}

export default request
